export const xs = "Pellentesque non est eros.";
export const s = "Maecenas sollicitudin convallis lectus, et venenatis turpis gravida et. Ut sagittis semper nisl, egestas faucibus diam dapibus id.";
export const m = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam pretium ultrices vestibulum. Nulla facilisi. Nullam mollis tristique nulla, non pharetra magna venenatis ac. Fusce fermentum nisi id felis maximus cursus. Aenean rutrum, nunc a iaculis tincidunt, justo nisl congue tortor, eu semper nisl mauris ac nibh.";

export const format = (s) => [s.slice(0,1).toUpperCase(), s.slice(1), '.'].join('');

export const medium = () => format(_.shuffle(m.split(' ')).join(' '));



// WEBPACK FOOTER //
// ./ui/loren.js